import { useState, useRef, useEffect } from "react"
import api from "../../../../services/api"
import { usePxoPage } from "../../../../contexts/PxoPageContext"
import { formatNumberBR } from "../../../../utils/stylesUtils"

const EditableCell = ({ 
	pxoProdutividadeTableValue,
	isSelected = false,
	isFillModeActive = false,
	onCellMouseDown,
	onCellMouseEnter
}) => {
	
	const [_isEditing, _setIsEditing] 			= useState(false)
	const [_value, _setValue] 					= useState(pxoProdutividadeTableValue.value)
	const [_originalValue, _setOriginalValue] 	= useState(pxoProdutividadeTableValue.value)

	const inputRef 		= useRef(null)
	const cancelEditRef = useRef(false)

	const { handleUpdateProdutividadeTable, handleUpdateOciosidadeCalculations } = usePxoPage()

	const handleStartEditing = () => {
		
		_setOriginalValue(pxoProdutividadeTableValue.value)
		_setValue(pxoProdutividadeTableValue.value)
		cancelEditRef.current = false
		_setIsEditing(true)
	}

	const handleEditNewValue = async () => {
		
		try {
			await api.put(
				`/updatePxoProdutividadeValue/${pxoProdutividadeTableValue.id}`,
				{ newValue: _value }
			)
		} catch (error) {
			console.error("Erro ao atualizar o valor:", error)
		}

		handleUpdateProdutividadeTable()
		handleUpdateOciosidadeCalculations()

	}

	useEffect(() => {
		
		if (_isEditing && inputRef.current) {
			inputRef.current.focus()
			inputRef.current.select()
		}

	}, [_isEditing])

	useEffect(() => {
		
		_setValue(pxoProdutividadeTableValue.value)

	}, [pxoProdutividadeTableValue.value])

	const handleBlur = async () => {

		_setIsEditing(false)

		if (cancelEditRef.current) {
			cancelEditRef.current = false
			_setValue(_originalValue)
			return
		}

		await handleEditNewValue()
	}

	const handleKeyDown = async (e) => {
		
		if (e.key === "Enter") {
			e.preventDefault()
			_setIsEditing(false)
			await handleEditNewValue()
		}

		if (e.key === "Escape") {
			e.preventDefault()
			cancelEditRef.current = true
			_setValue(_originalValue)
			_setIsEditing(false)
		}
	}

	return (
			<td
				onMouseDown={(e) => onCellMouseDown?.(e)}
				onMouseEnter={() => onCellMouseEnter?.()}
				onClick={() => {if (!_isEditing && !isFillModeActive) handleStartEditing()}}
				className={`
					text-right justify-right
					hover:bg-gray-200 transition
					hover:border-green-500 hover:border-[1px]
					hover:cursor-pointer
					text-[14px]
					${isSelected ? 'bg-blue-100 border-[1px] border-blue-400' : ''}
				`}
			>
				{_isEditing ? (
					<input
						ref={inputRef}
						type="text"
						value={_value}
						onChange={(e) => _setValue(e.target.value)}
						onBlur={handleBlur}
						onKeyDown={handleKeyDown}
						className="w-[40px] outline-none text-right text-[14px]"
					/>
				) : (
					formatNumberBR(_value)
				)}
			</td>
		)
}

export default EditableCell